import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Record } from '@app/core/models/live-zoom.model';
import { LiveService } from '@app/core/services/live.service';
import { SHARED_MODULES } from '@app/shared';
import { notNull } from '@app/shared/utils';
import { ClipboardService } from 'ngx-clipboard';
import { catchError, map, Observable, of, Subject, tap } from 'rxjs';

@Component({
  imports: [SHARED_MODULES],
  templateUrl: './modal-record.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalRecordComponent {
  private readonly liveService = inject(LiveService);
  public readonly dialogRef = inject<DialogRef<string>>(DialogRef);
  private readonly clipboardService = inject(ClipboardService);
  public readonly data = inject(DIALOG_DATA);
  public records$: Observable<Record>;
  public loading$ = new Subject<boolean>();
  public dateControl = new FormControl();

  constructor() {
    this.dateControl.valueChanges.subscribe((date) => {
      this.loadRecords(this.data, date);
    });
    this.dateControl.setValue(new Date());
  }

  public loadRecords(data: any, date: Date) {
    const dateStr = `${date.getFullYear()}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date
      .getDate()
      .toString()
      .padStart(2, '0')}`;

    this.records$ = this.liveService.controlLiveRecord(data.controlOptions.RecordingList, data.groupId, dateStr).pipe(
      notNull(),
      tap(() => this.loading$.next(true)),
      map((res: any) =>
        res.object.object.map((record: any) => ({
          descricao: record.descricao,
          data: record.data,
          h_start: record.h_start,
          h_end: record.h_end,
          senha: record.senha,
          url_video: record.url_video,
          url_audio: record.url_audio,
          start: record.start,
        })),
      ),
      catchError(() => of({ data: [] })),
      tap(() => this.loading$.next(false)),
    );
  }

  public copyKey(keyRecord) {
    this.clipboardService.copyFromContent(keyRecord);
  }
}
